import { jsx as H } from "react/jsx-runtime";
import { useState as A, useLayoutEffect as k, useEffect as E, useRef as y, useCallback as w, useMemo as U, createContext as B, useContext as G } from "react";
import { c as T, g as J } from "./_commonjsHelpers-DaMA6jEr.js";
var V = "Expected a function", D = NaN, K = "[object Symbol]", X = /^\s+|\s+$/g, Y = /^[-+]0x[0-9a-f]+$/i, q = /^0b[01]+$/i, Q = /^0o[0-7]+$/i, Z = parseInt, ee = typeof T == "object" && T && T.Object === Object && T, ne = typeof self == "object" && self && self.Object === Object && self, te = ee || ne || Function("return this")(), re = Object.prototype, oe = re.toString, ie = Math.max, ce = Math.min, I = function() {
  return te.Date.now();
};
function se(e, n, t) {
  var r, a, i, c, u, d, g = 0, b = !1, l = !1, o = !0;
  if (typeof e != "function")
    throw new TypeError(V);
  n = R(n) || 0, p(t) && (b = !!t.leading, l = "maxWait" in t, i = l ? ie(R(t.maxWait) || 0, n) : i, o = "trailing" in t ? !!t.trailing : o);
  function f(s) {
    var m = r, h = a;
    return r = a = void 0, g = s, c = e.apply(h, m), c;
  }
  function S(s) {
    return g = s, u = setTimeout(v, n), b ? f(s) : c;
  }
  function x(s) {
    var m = s - d, h = s - g, W = n - m;
    return l ? ce(W, i - h) : W;
  }
  function L(s) {
    var m = s - d, h = s - g;
    return d === void 0 || m >= n || m < 0 || l && h >= i;
  }
  function v() {
    var s = I();
    if (L(s))
      return F(s);
    u = setTimeout(v, x(s));
  }
  function F(s) {
    return u = void 0, o && r ? f(s) : (r = a = void 0, c);
  }
  function N() {
    u !== void 0 && clearTimeout(u), g = 0, r = d = a = u = void 0;
  }
  function P() {
    return u === void 0 ? c : F(I());
  }
  function C() {
    var s = I(), m = L(s);
    if (r = arguments, a = this, d = s, m) {
      if (u === void 0)
        return S(d);
      if (l)
        return u = setTimeout(v, n), f(d);
    }
    return u === void 0 && (u = setTimeout(v, n)), c;
  }
  return C.cancel = N, C.flush = P, C;
}
function p(e) {
  var n = typeof e;
  return !!e && (n == "object" || n == "function");
}
function ue(e) {
  return !!e && typeof e == "object";
}
function ae(e) {
  return typeof e == "symbol" || ue(e) && oe.call(e) == K;
}
function R(e) {
  if (typeof e == "number")
    return e;
  if (ae(e))
    return D;
  if (p(e)) {
    var n = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = p(n) ? n + "" : n;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(X, "");
  var t = q.test(e);
  return t || Q.test(e) ? Z(e.slice(2), t ? 2 : 8) : Y.test(e) ? D : +e;
}
var fe = se;
const _ = /* @__PURE__ */ J(fe);
var O = typeof window < "u" ? k : E;
function z(e, n, t, r) {
  const a = y(n);
  O(() => {
    a.current = n;
  }, [n]), E(() => {
    const i = window;
    if (!(i && i.addEventListener))
      return;
    const c = (u) => {
      a.current(u);
    };
    return i.addEventListener(e, c, r), () => {
      i.removeEventListener(e, c, r);
    };
  }, [e, t, r]);
}
function $(e) {
  const n = y(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return O(() => {
    n.current = e;
  }, [e]), w((...t) => {
    var r;
    return (r = n.current) == null ? void 0 : r.call(n, ...t);
  }, [n]);
}
var j = typeof window > "u";
function de(e, n, t = {}) {
  const { initializeWithValue: r = !0 } = t, a = w(
    (o) => t.serializer ? t.serializer(o) : JSON.stringify(o),
    [t]
  ), i = w(
    (o) => {
      if (t.deserializer)
        return t.deserializer(o);
      if (o === "undefined")
        return;
      const f = n instanceof Function ? n() : n;
      let S;
      try {
        S = JSON.parse(o);
      } catch (x) {
        return console.error("Error parsing JSON:", x), f;
      }
      return S;
    },
    [t, n]
  ), c = w(() => {
    const o = n instanceof Function ? n() : n;
    if (j)
      return o;
    try {
      const f = window.localStorage.getItem(e);
      return f ? i(f) : o;
    } catch (f) {
      return console.warn(`Error reading localStorage key “${e}”:`, f), o;
    }
  }, [n, e, i]), [u, d] = A(() => r ? c() : n instanceof Function ? n() : n), g = $((o) => {
    j && console.warn(
      `Tried setting localStorage key “${e}” even though environment is not a client`
    );
    try {
      const f = o instanceof Function ? o(c()) : o;
      window.localStorage.setItem(e, a(f)), d(f), window.dispatchEvent(new StorageEvent("local-storage", { key: e }));
    } catch (f) {
      console.warn(`Error setting localStorage key “${e}”:`, f);
    }
  }), b = $(() => {
    j && console.warn(
      `Tried removing localStorage key “${e}” even though environment is not a client`
    );
    const o = n instanceof Function ? n() : n;
    window.localStorage.removeItem(e), d(o), window.dispatchEvent(new StorageEvent("local-storage", { key: e }));
  });
  E(() => {
    d(c());
  }, [e]);
  const l = w(
    (o) => {
      o.key && o.key !== e || d(c());
    },
    [e, c]
  );
  return z("storage", l), z("local-storage", l), [u, g, b];
}
function le(e) {
  const n = y(e);
  n.current = e, E(
    () => () => {
      n.current();
    },
    []
  );
}
function me(e, n = 500, t) {
  const r = y();
  le(() => {
    r.current && r.current.cancel();
  });
  const a = U(() => {
    const i = _(e, n, t), c = (...u) => i(...u);
    return c.cancel = () => {
      i.cancel();
    }, c.isPending = () => !!r.current, c.flush = () => i.flush(), c;
  }, [e, n, t]);
  return E(() => {
    r.current = _(e, n, t);
  }, [e, n, t]), a;
}
var ge = typeof window > "u";
function ve(e = {}) {
  let { initializeWithValue: n = !0 } = e;
  ge && (n = !1);
  const [t, r] = A(() => n ? {
    width: window.innerWidth,
    height: window.innerHeight
  } : {
    width: void 0,
    height: void 0
  }), a = me(
    r,
    e.debounceDelay
  );
  function i() {
    (e.debounceDelay ? a : r)({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }
  return z("resize", i), O(() => {
    i();
  }, []), t;
}
const he = "element-theme", we = "light", M = B(null), Te = () => {
  const e = G(M);
  if (!e)
    throw new Error(
      "useElementTheme must be used within an ElementThemeProvider"
    );
  return e;
}, ye = ({ children: e }) => {
  const [n, t] = de(
    he,
    we
  ), a = {
    themeName: n,
    toggleTheme: (i) => {
      t(i);
    }
  };
  return /* @__PURE__ */ H(M.Provider, { value: a, children: e });
};
export {
  M as E,
  ye as a,
  ve as b,
  Te as u
};
